import React, { useEffect, useRef } from 'react';
import './client.css';
import { Link } from 'react-router-dom';
import { formatDateIndo } from './utils/dateHelper';
import './App.css';

function Client() {
  const testiRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const testiElements = testiRef.current?.querySelectorAll('.client-testimonial');
    testiElements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Professional testimonials untuk digital agency (hanya yang memiliki demo portfolio)
  const testimonials = [
    {
      id: 1,
      clientType: 'Medius Quran',
      industry: 'Education',
      rating: 4,
      content: 'Website yang dibuat oleh Cakra Digital Innovation sangat profesional dan sesuai dengan kebutuhan bisnis kami. Desainnya modern dan mudah digunakan.',
      projectType: 'Company Profile Website',
      date: formatDateIndo(new Date('2025-02-21')),
      category: 'Web Aplikasi Edukasi / Self-Assessment Platform',
      duration: '3 minggu',
      features: ['Landing Page Profesional', 'Sistem Analisis Diri', 'Video Introduction', 'CTA Button', 'Navigasi Modular berbasi konsep', 'Branding Visual Moderen (dark UI, clean, tech feel)', 'Spiritual / energi diri', 'Personal development', 'Wellness system'],
      tags: ['HTML5', 'CSS3', 'JavaScript'],
     url: 'https://medius-quran.gt.tc/',
      verified: true
    },
    {
      id: 2,
      clientType: 'Sewa Bus Jabodetabek',
      industry: 'Transportation & Travel',
      rating: 5,
      content: 'Website sewa bus yang dikembangkan sangat membantu meningkatkan pemesanan online kami. Sistemnya mudah digunakan oleh pelanggan dan sangat efektif dalam mengelola jadwal serta ketersediaan armada.',
      projectType: 'Transportation Booking Website',
      date: formatDateIndo(new Date('2024-12-15')),
      category: 'Website Development',
      duration: '2 bulan',
      features: ['Real-time booking system', 'Fleet management', 'Customer dashboard', 'Payment integration'],
      tags: ['React', 'Firebase', 'Material-UI', 'WebSockets'],
      url: 'https://sewa-bus-jabodetabek.netlify.app/',
      verified: true
    }
  ];

  const industries = [
    {
      icon: '🛍️',
      name: 'Retail & E-Commerce',
      description: 'Toko online, marketplace, dan sistem penjualan digital',
      count: 0,
      growth: '+0%',
      color: '#3b82f6'
    },
    {
      icon: '🏢',
      name: 'Corporate & B2B',
      description: 'Company profile, sistem manajemen, dan solusi bisnis',
      count: 0,
      growth: '+0%',
      color: '#10b981'
    },
    {
      icon: '🍽️',
      name: 'F&B & Hospitality',
      description: 'Restoran, cafe, dan sistem manajemen kuliner',
      count: 1,
      growth: '+100%',
      color: '#f59e0b'
    },
    {
      icon: '🏥',
      name: 'Healthcare',
      description: 'Klinik, apotek, dan sistem manajemen kesehatan',
      count: 1,
      growth: '+100%',
      color: '#ef4444'
    },
    {
      icon: '🎓',
      name: 'Education',
      description: 'Lembaga pendidikan, kursus online, dan e-learning',
      count: 0,
      growth: '+0%',
      color: '#8b5cf6'
    },
    {
      icon: '🏭',
      name: 'Manufacturing',
      description: 'Pabrik, industri kecil, dan sistem produksi',
      count: 0,
      growth: '+0%',
      color: '#64748b'
    }
  ];

  const achievements = [
    {
      icon: '📈',
      title: 'Average Growth',
      value: '245%',
      description: 'Rata-rata klien mengalami peningkatan signifikan dalam penjualan dan traffic',
      color: '#10b981'
    },
    {
      icon: '⏱️',
      title: 'Average Duration',
      value: '4 minggu',
      description: 'Waktu pengerjaan rata-rata untuk proyek dari mulai development hingga launching',
      color: '#3b82f6'
    },
    {
      icon: '😊',
      title: 'Satisfaction Rate',
      value: '98%',
      description: 'Tingkat kepuasan klien berdasarkan feedback dan review setelah project selesai',
      color: '#f59e0b'
    },
    {
      icon: '🔄',
      title: 'Retention Rate',
      value: '85%',
      description: 'Persentase klien yang kembali menggunakan layanan kami untuk proyek berikutnya',
      color: '#8b5cf6'
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>⭐</span>
    ));
  };

  return (
    <>
      <section className="client-hero">
        <div className="client-hero__inner">
          <div className="client-hero__content">
            <span className="client-hero__badge">🏆 Client Success Stories</span>
            <h1 className="client-hero__title">
              <span className="client-hero__title-main">Trusted by</span>
              <span className="client-hero__title-accent">3+ Happy Clients</span>
            </h1>
            <p className="client-hero__subtitle">
              Real testimonials from our satisfied clients with live demo projects. See how we've helped businesses 
              through our digital solutions and achieved remarkable growth.
            </p>
            <div className="client-hero__stats">
              <div className="client-hero__stat">
                <div className="client-hero__stat-number">3+</div>
                <div className="client-hero__stat-label">Projects Completed</div>
              </div>
              <div className="client-hero__stat">
                <div className="client-hero__stat-number">3+</div>
                <div className="client-hero__stat-label">Happy Clients</div>
              </div>
              <div className="client-hero__stat">
                <div className="client-hero__stat-number">1+</div>
                <div className="client-hero__stat-label">Years Experience</div>
              </div>
            </div>
            <div className="client-hero__trust">
              <div className="trust-badges">
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Verified Projects</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
                    <path d="M12 7v3m0 0v.01M12 21a9 9 0 110-18 0 9 9 0 010 18z"/>
                  </svg>
                  <span>Real Results</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Proven Success</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="client-industries">
        <div className="client-industries__inner">
          <div className="section-header">
            <h2 className="section-title">Industries We Serve</h2>
            <p className="section-subtitle">Digital solutions for diverse business sectors</p>
          </div>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card" style={{ '--accent-color': industry.color }}>
                <div className="industry-card__icon">{industry.icon}</div>
                <h3 className="industry-card__name">{industry.name}</h3>
                <p className="industry-card__description">{industry.description}</p>
                <div className="industry-card__stats">
                  <div className="industry-card__count">
                    <span className="industry-card__number">{industry.count}</span>
                    <span className="industry-card__label">Clients</span>
                  </div>
                  <div className="industry-card__growth">
                    <span className="industry-card__growth-number">{industry.growth}</span>
                    <span className="industry-card__growth-label">Growth</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="client-testimonials" ref={testiRef}>
        <div className="client-testimonials__inner">
          <div className="section-header">
            <h2 className="section-title">Client Testimonials</h2>
            <p className="section-subtitle">What our satisfied clients say about their website projects</p>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-card__header">
                  <div className="testimonial-card__quote-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4C2.75 3 2 3.75 2 5v8c0 1-1 2-2 2v1z"/>
                      <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2h-4c-1.25 0-2 .75-2 2v8c0 1-1 2-2 2v1z"/>
                    </svg>
                  </div>
                  <div className="testimonial-card__info">
                    <div className="testimonial-card__client-type">{testimonial.clientType}</div>
                    <div className="testimonial-card__industry">{testimonial.industry}</div>
                    <div className="testimonial-card__meta">
                      <span className="testimonial-card__category">{testimonial.category}</span>
                      <span className="testimonial-card__date">{testimonial.date}</span>
                    </div>
                  </div>
                  <div className="testimonial-card__rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
                <div className="testimonial-card__content">
                  <p>"{testimonial.content}"</p>
                </div>
                <div className="testimonial-card__footer">
                  <div className="testimonial-card__project-info">
                    <h4 className="testimonial-card__project-title">{testimonial.projectType}</h4>
                    <div className="testimonial-card__project-details">
                      <div className="testimonial-card__project-detail">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"/>
                          <polyline points="12 6 12 12 16 14"/>
                        </svg>
                        <span>{testimonial.duration}</span>
                      </div>
                      <div className="testimonial-card__project-detail">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H17"/>
                        </svg>
                        <span>{testimonial.investment}</span>
                      </div>
                    </div>
                    <div className="testimonial-card__project-features">
                      {testimonial.features.map((feature, index) => (
                        <span key={index} className="testimonial-card__feature">{feature}</span>
                      ))}
                    </div>
                  </div>
                  <div className="testimonial-card__results">
                    <div className="testimonial-card__result">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                      </svg>
                      <span className="testimonial-card__result-text">{testimonial.results}</span>
                    </div>
                  </div>
                  {testimonial.url && (
                    <div className="testimonial-card__action">
                      <a 
                        href={testimonial.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="testimonial-card__link"
                      >
                        <span>View Project</span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                        </svg>
                      </a>
                    </div>
                  )}
                </div>
                <div className="testimonial-card__verified">
                  <div className="testimonial-card__verified-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                    <span>Verified Client</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="client-achievements">
        <div className="client-achievements__inner">
          <div className="section-header">
            <h2 className="section-title">Client Success Impact</h2>
            <p className="section-subtitle">Proven results from our happy clients</p>
          </div>
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-card" style={{ '--accent-color': achievement.color }}>
                <div className="achievement-card__icon">{achievement.icon}</div>
                <h3 className="achievement-card__title">{achievement.title}</h3>
                <div className="achievement-card__metric">
                  <span className="achievement-card__number">{achievement.value}</span>
                </div>
                <p className="achievement-card__description">{achievement.description}</p>
                <div className="achievement-card__trend">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                  </svg>
                  <span>Client Success</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="client-cta">
        <div className="client-cta__inner">
          <div className="client-cta__content">
            <h2 className="client-cta__title">Join Our Happy Clients</h2>
            <p className="client-cta__subtitle">
              Ready to be our next happy client with a live demo project? Let's discuss how we can help transform your business digitally.
            </p>
            <div className="client-cta__buttons">
              <Link to="/consultation" className="btn btn-primary btn-large">
                <span className="btn__icon">💬</span>
                <span>Start Your Project</span>
              </Link>
              <Link to="/portfolio" className="btn btn-secondary btn-large">
                <span className="btn__icon">🎨</span>
                <span>View Our Portfolio</span>
              </Link>
            </div>
            <div className="client-cta__stats">
              <div className="client-cta__stat">
                <div className="client-cta__stat-number">3+</div>
                <div className="client-cta__stat-label">Projects Completed</div>
              </div>
              <div className="client-cta__stat">
                <div className="client-cta__stat-number">3+</div>
                <div className="client-cta__stat-label">Happy Clients</div>
              </div>
              <div className="client-cta__stat">
                <div className="client-cta__stat-number">1+</div>
                <div className="client-cta__stat-label">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Client;
